import Cookies from "js-cookie";
import React, { useState, useMemo, createContext } from "react";
import { usePostHog } from 'posthog-js/react';

// create context
export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [cartDrawerOpen, setCartDrawerOpen] = useState(false);
  const [categoryDrawerOpen, setCategoryDrawerOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const posthog = usePostHog();

  const toggleCartDrawer = () => {
    // Check if there's a coupon applied before removing
    const couponInfo = Cookies.get("couponInfo");
    if (couponInfo) {
      try {
        const parsedCoupon = JSON.parse(couponInfo);
        // PostHog Coupon Removed event
        posthog?.capture('Coupon Removed', {
          order_id: null,
          cart_id: null,
          coupon_id: parsedCoupon.couponCode?.toLowerCase() || null,
          coupon_name: parsedCoupon.title || null,
          reason: 'Cart drawer toggled'
        });
      } catch (error) {
        console.error('Error parsing coupon info:', error);
      }
    }
    
    setCartDrawerOpen(!cartDrawerOpen);
    Cookies.remove("couponInfo");

    setIsUpdate(!isUpdate);
  };
  const closeCartDrawer = () => setCartDrawerOpen(false);
  const openCartDrawer = () => setCartDrawerOpen(true);

  const toggleCategoryDrawer = () => setCategoryDrawerOpen(!categoryDrawerOpen);
  const closeCategoryDrawer = () => setCategoryDrawerOpen(false);

  const toggleModal = () => {
    console.log("col");
    setIsModalOpen(!isModalOpen);
  };
  const closeModal = () => setIsModalOpen(false);

  const toggleUpdater = () => setIsUpdate(!isUpdate);

  const value = useMemo(
    () => ({
      cartDrawerOpen,
      toggleCartDrawer,
      closeCartDrawer,
      setCartDrawerOpen,
      categoryDrawerOpen,
      toggleCategoryDrawer,
      closeCategoryDrawer,
      isModalOpen,
      toggleModal,
      closeModal,
      toggleUpdater,
      isUpdate,
      openCartDrawer,
    }),

    [cartDrawerOpen, categoryDrawerOpen, isModalOpen, isUpdate]
  );

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};
